import { ReactNode } from 'react';
import { Box, Stack, Typography } from '@mui/material';

export function BookRailLabel({ index, title }: { index?: string; title: string }) {
  return (
    <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 0.85 }}>
      {index && (
        <Box sx={{
          width: 18,
          height: 18,
          borderRadius: '4px',
          bgcolor: '#0f172a',
          color: '#fff',
          fontSize: 10,
          fontWeight: 800,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          letterSpacing: 0,
        }}>
          {index}
        </Box>
      )}
      <Typography variant="caption" sx={{ fontWeight: 800, letterSpacing: '0.1em', color: '#64748b', textTransform: 'uppercase' }}>
        {title}
      </Typography>
    </Stack>
  );
}

export function BookSectionTitle({
  icon, title, hint, accent,
}: {
  icon: ReactNode;
  title: string;
  hint?: string;
  accent: string;
}) {
  return (
    <Stack direction="row" alignItems="center" spacing={1} mb={1.25}>
      <Box sx={{ color: accent, display: 'flex', alignItems: 'center' }}>{icon}</Box>
      <Box minWidth={0}>
        <Typography variant="subtitle2" fontWeight={800} letterSpacing="-0.02em" noWrap>{title}</Typography>
        {hint && (
          <Typography variant="caption" color="text.secondary" sx={{ display: 'block', lineHeight: 1.2 }}>
            {hint}
          </Typography>
        )}
      </Box>
    </Stack>
  );
}
